import { useContext } from 'react';
import CartContext from '../../../store/cart-context';
import classes from './Mealitem.module.css'
import MealitemForm from './MealitemForm';

const Mealitem = props => {
    const cartCtx = useContext(CartContext)
    const price = `$${props.price.toFixed(2)}`
    const addItemToCartHandler = amount =>{
        cartCtx.addItem({
            id:props.id,
            name:props.name,
            amount:amount,
            price:props.price
        })
    }
    return <li>
        <div>
            <h3>{props.name}</h3>
            <div className={classes.description}>{props.description}</div>
            <div className={classes.price}>{price}</div>
        </div>
        <div>
            <MealitemForm id = {props.id} onAddToCart = {addItemToCartHandler}/>
        </div>
    </li>
}
export default Mealitem;